/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SubscriptionTypeEnum {
    PRO = 'PRO',
    AD_FREE = 'AD_FREE',
}
